import { render, staticRenderFns } from "./ModalCreateSynonym.vue?vue&type=template&id=1d494d4e&"
import script from "./ModalCreateSynonym.vue?vue&type=script&lang=js&"
export * from "./ModalCreateSynonym.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports